export default {
  "Your email address": `Vaše e-mailová adresa`,
  "Fill This Field": `Vyplňte toto pole`,
  "FillThisField": `Vyplňte toto pole`,
  "Log In": `Přihlásit se`,
  "Send": `Odeslat`,
  "Button": {
    "Continue": `Pokračovat`,
  },
  "login": {
    "WELCOME BACK": `VÍTEJ ZPĚT`,
    "New to Swipe": `Nový ve Swipe`,
    "Sign up": `Zaregistrovat se`,
    "Your password": `Vaše heslo`,
    "Forgot your password": `Zapomněli jste heslo`,
    "Log In": `Přihlásit se`,
  },
  "forgot-password": {
    "forgot-password": `zapomenuté heslo`,
    "descriptions": `Zadejte prosím svou registrovanou e-mailovou adresu, abyste obdrželi pokyny k obnovení hesla`,
    "descriptions1": `Na vaši e-mailovou adresu byl odeslán e-mail pro obnovení hesla.`,
    "Your email address": `Vaše e-mailová adresa`,
    "Send": `Odeslat`,
    "Recovery Password": `Obnovení hesla`,
    "Create a new": `Vytvořte nové silné heslo, které nepoužíváte na žádných jiných webových stránkách.`,
    "The password must": `Heslo musí obsahovat jedno velké písmeno, jedno číslo a mít délku alespoň 8 znaků!`,
  },
  "signup": {
    "CREATE ACCOUNT": `VYTVOŘIT ÚČET`,
    "Already have an account": `Už máte účet`,
    "Business": `Firemní`,
    "Personal": `Osobní`,
    "Company name": `Název společnosti`,
    "CountryOfIssuance": `Země vydání`,
    "SignUpCheckBox": `Registrací souhlasíte s našimi Podmínkami používání a Zásadami ochrany osobních údajů`,
    "Phone": `Telefon`,
    "SMS code": `SMS kód`,
    "Country of issuance": `Země vydání`,
  },
};
